// extracted by mini-css-extract-plugin
module.exports = {"ContrastTable":"ContrastTable_ContrastTable__jwSrU"};